import * as React from 'react';
import { SxSV2 } from './SxSV2';
import { logUsage } from 'owa-analytics';
import { GenericKeys } from 'owa-analytics/lib/types/DatapointEnums';
import { getStore } from 'owa-popout-v2/lib/store/parentStore';
import { findTabIdBySxSId } from 'owa-tab-store';

const styles = require('./ProjectionSxSV2.scss');

export default function ProjectionSxSV2({ sxsId }: { sxsId: string }) {
    React.useEffect(() => {
        // Remove after sxs-popout-projection is graduated
        const tabId = findTabIdBySxSId(sxsId);
        const store = getStore();
        const viewState = store.projections.filter(projection => projection.tabId == tabId)[0];

        const timeElapsed = viewState?.datapoint?.getData(GenericKeys.e2eTimeElapsed);
        if (!!timeElapsed) {
            logUsage('PopOutSxSUsage', {
                PopOutType: 'ProjectionPopout',
                TimeElapsed: timeElapsed,
            });
        }
    }, []);

    return (
        <div className={styles.projectionSxSV2}>
            <SxSV2 sxsId={sxsId} />
        </div>
    );
}
